/* eslint linebreak-style: ["error", "unix"] */
import Modal from 'components/modals/modal/modal';
import CloseButtonWhite from 'components/buttons/button-close/close-button.white';
import { getPublicationByIdGql, Publication as IPublication } from 'data/publications';
import { ModalQueryParams } from 'data/app';
import DataRenderer from 'components/data-renderer/data-renderer';
import SectionTitle from 'components/section-title/section-title';
import BackofficePublicationForm from 'components/forms/form-publication/backoffice-publication-form';
import { useModalStyles } from 'styles/modal.styles';
import useModalQueryWithId from 'hooks/useModalQueryWithId';

export default function BackofficeEditPublicationModal() {
  const classes = useModalStyles();

  const {
    data, loading, errorMessage, isOpen, handleClose,
  } = useModalQueryWithId<IPublication>(
    ModalQueryParams.EDIT_PUBLICATION,
    getPublicationByIdGql,
    'getPublicationById',
  );

  return (
    <Modal
      className={classes.modal}
      open={isOpen}
      onClose={handleClose}
      closeButtonComponent={CloseButtonWhite}
      hasCloseButton
    >
      <DataRenderer loading={loading} error={errorMessage}>
        <SectionTitle>Editar publicação</SectionTitle>
        <BackofficePublicationForm
          data={data}
          onSuccess={() => {
            handleClose();
          }}
        />
      </DataRenderer>
    </Modal>
  );
}
